export default "__VITE_ASSET__Yp2$EWMK__"